var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-reports animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _vm.$store.getters.roleID === _vm.Roles.SUPER_ADMIN ||
            _vm.$store.getters.roleID === _vm.Roles.ADMIN
              ? _c("b-card", [
                  _c("h1", { staticClass: "lbv-page-title" }, [
                    _vm._v("\n          Reports\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.downloadReports.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "report rounded-pill",
                          attrs: { variant: "primary", type: "submit" },
                        },
                        [
                          _c("span", { staticClass: "download" }, [
                            _vm._v("Customer Overview"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.roleID === _vm.Roles.MAINTENANCE ||
            _vm.$store.getters.roleID === _vm.Roles.EXT_OPS ||
            _vm.$store.getters.roleID === _vm.Roles.INSURANCE
              ? _c("b-card", [
                  _c("h1", { staticClass: "lbv-page-title" }, [
                    _vm._v("\n          Reports\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.downloadReportsSO.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "report rounded-pill",
                          attrs: { variant: "primary", type: "submit" },
                        },
                        [
                          _c("span", { staticClass: "download" }, [
                            _vm._v("Customer Overview"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "reportErr",
          attrs: { show: _vm.errorString != "", variant: "danger" },
        },
        [_vm._v("\n    " + _vm._s(_vm.errorString) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }